<template>
  <!--srcviewscompanydetailsBusinessActivitiesSupplyChainvuehtmlStart-->

  <div id="defaultId1 " style="padding-bottom: 20px">
    <gui_card
      id="ge6845"
      class="uc1096 pb20 margin-bottom10"
      label=""
      :isShowLabel="false"
    >
      <div>
        <h2 class="operations-head-content" style="align-items: center">
          <span class="operations-head" style="color: #009ea7;"
            >{{ $t("TradeByCountry.TradeCompetitivenessIndex") }}
            <span class="Color009EA7 font_bold margin-left20">{{
              CountryObjectTwo?.status
            }}</span></span
          >
          <span class="font18"
            >{{ $t("TradeByCountry.Updateyear") }}:{{ CountryObjectTwo?.updateYear || '-' }}</span
          >
        </h2>
        <div class="flex_center_between_box">
          <div style="width: 50%">
            <p class="CountryUsd" style="border-top: 1px solid #ccc">
              <span class="CountryUsdspan">{{ $t("TradeByCountry.TotalTradeAmount") }}</span
              >{{ CountryObjectTwo?.totalTrade || '-' }}
            </p>
            <p class="CountryUsd">
              <span class="CountryUsdspan"> {{ $t("TradeByCountry.TotalExportAmount") }}</span
              >{{ CountryObjectTwo?.totalExport || '-' }}
            </p>
            <p class="CountryUsd">
              <span class="CountryUsdspan">{{ $t("TradeByCountry.TotalImportAmount") }}</span
              >{{ CountryObjectTwo?.totalImport || '-' }}
            </p>
            <p class="CountryUsd">
              <span class="CountryUsdspan">{{ $t("TradeByCountry.NetTradeBalance") }}</span
              >{{ CountryObjectTwo?.tradeNetBalance || '-' }}
            </p>
            <p class="CountryUsd">
              <span class="CountryUsdspan">{{ $t("TradeByCountry.TradeGap") }}</span
              >{{ CountryObjectTwo?.tradeGap || '-' }}
            </p>
            <p class="CountryUsd">
              <span class="CountryUsdspan">{{ $t("TradeByCountry.TradeGoodsExports") }}</span
              >{{ CountryObjectTwo?.tradeGoodsExports || '-' }}
            </p>
            <p class="CountryUsd">
              <span class="CountryUsdspan">{{ $t("TradeByCountry.TradeGoodsImports") }}</span
              >{{ CountryObjectTwo?.tradeGoodsImports || '-' }}
            </p>
            <p class="CountryUsd">
              <span class="CountryUsdspan">{{ $t("TradeByCountry.TradeServicesExports") }}</span
              >{{ CountryObjectTwo?.tradeServicesExports || '-' }}
            </p>
          </div>
          <div style="width: 50%">
            <p class="CountryUsd" style="border-top: 1px solid #ccc">
              <span class="CountryUsdspan">{{ $t("TradeByCountry.TradeServicesImports") }}</span
              >{{ CountryObjectTwo?.tradeServicesImports || '-' }}
            </p>
            <p class="CountryUsd">
              <span class="CountryUsdspan">{{ $t("TradeByCountry.CompositePMI") }}</span
              >{{ CountryObjectTwo?.compositePMI || '-' }}
            </p>
            <p class="CountryUsd">
              <span class="CountryUsdspan">{{ $t("TradeByCountry.ServicesPMI") }}</span
              >{{ CountryObjectTwo?.servicesPMI || '-' }}
            </p>
            <p class="CountryUsd">
              <span class="CountryUsdspan">{{ $t("TradeByCountry.LegalEnvironment") }}</span
              >{{ CountryObjectTwo?.legalEnvironment || '-' }}
            </p>
            <p class="CountryUsd">
              <span class="CountryUsdspan">{{ $t("TradeByCountry.CorporateTaxRate") }}</span
              >{{ CountryObjectTwo?.corporateTaxRate || '-' }}
            </p>
            <p class="CountryUsd">
              <span class="CountryUsdspan">{{ $t("TradeByCountry.PersonalIncomeTaxRate") }}</span
              >{{ CountryObjectTwo?.personalIncomeTaxRate || '-' }}
            </p>
            <p class="CountryUsd">
              <span class="CountryUsdspan">{{ $t("TradeByCountry.SalesTaxRate") }}</span
              >{{ CountryObjectTwo?.salesTaxRate || '-' }}
            </p>
            <p class="CountryUsd">
              <span class="CountryUsdspan">{{ $t("TradeByCountry.BusinessConfidenceIndex") }}</span
              >{{ CountryObjectTwo?.businessConfidence || '-' }}
            </p>
          </div>
        </div>
      </div>
    </gui_card>
    <gui_card id="ge6845" class="uc1096 pb20" label="" :isShowLabel="false">
      <div>
        <h2 class="operations-head-content">
          <span class="operations-head" style="color: #009ea7;">{{ $t("TradeByCountry.CountryRating") }}</span>
        </h2>
        <div class="flex_center_between_box">
          <div style="width: 50%">
            <p class="CountryUsd" style="border-top: 1px solid #ccc">
              <span class="CountryUsdspan">{{ $t("TradeByCountry.CompetitivenessIndex") }}</span
              >{{ CountryObject?.competitivenessIndex || '-' }}
            </p>
            <p class="CountryUsd">
              <span class="CountryUsdspan">{{ $t("TradeByCountry.CompetitivenessRank") }}</span
              >{{ CountryObject?.competitivenessRank || '-' }}
            </p>
            <p class="CountryUsd">
              <span class="CountryUsdspan">{{ $t("TradeByCountry.EaseofDoingBusiness") }}</span
              >{{ CountryObject?.easeOfDoingBusiness || '-' }}
            </p>
            <p class="CountryUsd">
              <span class="CountryUsdspan">{{ $t("TradeByCountry.LegalEnvironment") }}</span
              >{{ CountryObject?.legalEnvironment || '-' }}
            </p>
            <p class="CountryUsd">
              <span class="CountryUsdspan">{{ $t("TradeByCountry.BusinessConfidence") }}</span
              >{{ CountryObject?.businessConfidence || '-' }}
            </p>
            <p class="CountryUsd">
              <span class="CountryUsdspan">{{ $t("TradeByCountry.ConsumerConfidence") }}</span
              >{{ CountryObject?.consumerConfidence || '-' }}
            </p>
            <p class="CountryUsd">
              <span class="CountryUsdspan">{{ $t("TradeByCountry.BusinessClimateAssessment") }}</span
              >{{ CountryObject?.businessClimateAssessment || '-' }}
            </p>
            <p class="CountryUsd">
              <span class="CountryUsdspan">{{ $t("TradeByCountry.SP") }}</span>{{ CountryObject?.sp || '-' }}
            </p>
          </div>
          <div style="width: 50%">
            <p class="CountryUsd" style="border-top: 1px solid #ccc">
              <span class="CountryUsdspan">{{ $t("TradeByCountry.Moodys") }}</span
              >{{ CountryObject?.moodyRating || '-' }}
            </p>
            <p class="CountryUsd">
              <span class="CountryUsdspan">{{ $t("TradeByCountry.Fitch") }}</span
              >{{ CountryObject?.fitchRating || '-' }}
            </p>
            <p class="CountryUsd">
              <span class="CountryUsdspan">{{ $t("TradeByCountry.DBRS") }}</span
              >{{ CountryObject?.dbrsRating || '-' }}
            </p>
            <p class="CountryUsd">
              <span class="CountryUsdspan">{{ $t("TradeByCountry.Allianz") }}</span
              >{{ CountryObject?.allianzRating || '-' }}
            </p>
            <p class="CountryUsd">
              <span class="CountryUsdspan">{{ $t("TradeByCountry.Coface") }}</span
              >{{ CountryObject?.cofaceRating || '-' }}
            </p>
            <p class="CountryUsd">
              <span class="CountryUsdspan">{{ $t("TradeByCountry.Atradius") }}</span
              >{{ CountryObject?.atradiusRating || '-' }}
            </p>
            <p class="CountryUsd">
              <span class="CountryUsdspan">{{ $t("TradeByCountry.OECD") }}</span
              >{{ CountryObject?.oecdRiskCategory || '-' }}
            </p>
            <p class="CountryUsd"><span class="CountryUsdspan"></span></p>
          </div>
        </div>
      </div>
    </gui_card>

    <ReLogin :reLoginPop="reLoginVis"></ReLogin>
  </div>
</template>

<script>
import {
  getCountryRatings,
  getTradeCompetitivenessIndex,
} from "@/api/companyApi.js";
import rectcard from "@/components/rectCard/index.vue";
import content_text from "@/components/text_content/index.vue";
import ReLogin from "../../../../components/ReLogin.vue";
import gui_card from "@/components/gui_card/gui_card.vue";
import { nextTick } from "vue";
export default {
  name: "",
  // props: {},
  components: {
    gui_card,
    // gui_card end

    rectcard,
    content_text,
    ReLogin,
  },
  data() {
    return {
      datePicker: [],
      dateImportPicker: [],

      CountryObject: {},
      CountryObjectTwo: {},
      importTableData: [],
      reLoginVis: false,
    };
  },
  mounted() {
    this.$store.dispatch("app/setTools", {
      name: "menu",
      key: "isActive",
      value: false,
    });
    this.getmportData();
    this.$emit("UpdatamarkTotalList", true);
  },
  methods: {
    ChangeEcportDate() {
      this.getexportData();
    },

    getmportData() {
      getCountryRatings({
        countryCode: this.$route.query.id3a,
      }).then((res) => {
        if (res.code == 200) {
          this.CountryObject = res.data;
        }
      });
      getTradeCompetitivenessIndex({
        countryCode: this.$route.query.id3a,
      }).then((res) => {
        if (res.code == 200) {
          this.CountryObjectTwo = res.data;
        }
      });
    },
  },
  computed: {},
};
</script>
<style scoped>
@media (max-width: 1920px) {
  .head-titel {
    font-size: 20px;
    height: 30px;
  }
}
@media (max-width: 1439px) {
  .head-titel {
    font-size: 18px;
    height: 26px;
  }
}

.flex_center_between_box {
  display: flex;
  justify-content: space-between;
}

#cb02bf {
  padding-bottom: 20px;
}
@media (max-width: 1920px) {
  #cb02bf {
    padding-bottom: 15px;
  }
}
@media (max-width: 1439px) {
  #cb02bf {
    padding-bottom: 13px;
  }
}

.uc1096 {
  height: 100%;
}

.uUIRzUi {
  padding: 30px 40px 41px 40px;
  box-shadow: 0px 2px 14px 0px rgba(0, 0, 0, 0.12);
  border-radius: 10px;
}

@media (max-width: 1920px) {
  .uUIRzUi {
    padding: 22px 30px 30px 30px;
    box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.12);
    border-radius: 10px;
  }
}
@media (max-width: 1439px) {
  .uUIRzUi {
    padding: 20px 26px 26px 26px;
    box-shadow: 0px 1px 9px 0px rgba(0, 0, 0, 0.12);
    border-radius: 5px;
  }
}

.CountryUsd {
  width: 100%;
  height: 61px;
  color: #1a2332;
  font-size: 18px;
  display: flex;
  border-bottom: 1px solid #cccccc;
  align-items: center;
}
@media (max-width: 1920px) {
  .CountryUsd {
    height: 45px;
    font-size: 16px;
  }
}
@media (max-width: 1439px) {
  .CountryUsd {
    height: 40px;
    font-size: 14px;
  }
}

.CountryUsdspan {
  width: 300px;
  background: #f2f5f9;
  font-size: 18px;
  font-family: "Arial Bold" !important;
  display: inline-block;
  height: 100%;
  display: flex;
  align-items: center;
  padding-left: 20px;
  margin-right: 40px;
}
@media (max-width: 1920px) {
  .CountryUsdspan {
    width: 260px;
    font-size: 16px;
    padding-left: 15px;
    margin-right: 22px;
  }
}
@media (max-width: 1439px) {
  .CountryUsdspan {
    width: 200px;
    font-size: 14px;
    padding-left: 13px;
    margin-right: 26px;
  }
}
</style>
